import React from 'react';

const HighlightedText = ({ text }) => {
  return <span className="font-bold text-blue-100"> {text}</span>;
};

export default HighlightedText;
